import { UseClaimableRewardsResult, useClaimableRewards } from './useClaimableRewards'
import { UseClaimableRewardsSummaryResult, useClaimableRewardsSummary } from './useClaimableRewardsSummary'
import { UseOngoingCampaignsResult, useOngoingCampaigns } from './useOngoingCampaigns'
import { useOpenDialog } from '@/domain/state/dialogs/hooks'
import { selectNetworkDialogConfig } from '@/features/dialogs/select-network/SelectNetworkDialog'

export interface UseSparkRewardsResult {
  ongoingCampaignsResult: UseOngoingCampaignsResult
  claimableRewardsResult: UseClaimableRewardsResult
  claimableRewardsSummaryResult: UseClaimableRewardsSummaryResult
  selectNetwork: () => void
}

export function useSparkRewards(): UseSparkRewardsResult {
  const claimableRewardsResult = useClaimableRewards()
  const ongoingCampaignsResult = useOngoingCampaigns()
  const claimableRewardsSummaryResult = useClaimableRewardsSummary()
  const openDialog = useOpenDialog()

  function selectNetwork(): void {
    openDialog(selectNetworkDialogConfig, {})
  }

  return {
    ongoingCampaignsResult,
    claimableRewardsResult,
    claimableRewardsSummaryResult,
    selectNetwork,
  }
}
